import getEmailAddressForAllAccounts from './getEmailAddressForAllAccounts';

export default function getHasMultipleAccounts(): boolean {
    return getEmailAddressForAllAccounts().length > 1;
}
